<template>
  <v-dialog
    :model-value="modelValue"
    max-width="520"
    persistent
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <v-card class="confirm-dialog-card" rounded="xl">
      <v-card-text class="pa-6 pa-md-7">
        <div class="confirm-dialog-icon">
          <v-icon :icon="icon" size="30" :color="color" />
        </div>
        <p class="confirm-dialog-eyebrow">Megerősítés</p>
        <h2 class="confirm-dialog-title">{{ title }}</h2>
        <p class="confirm-dialog-text">{{ text }}</p>
      </v-card-text>

      <v-card-actions class="justify-end px-6 pb-6 pt-0 ga-2">
        <v-btn variant="text" color="secondary" @click="$emit('cancel')">
          {{ cancelText }}
        </v-btn>
        <v-btn :color="color" variant="flat" @click="$emit('confirm')">
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "AppConfirmDialog",
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "Biztosan folytatod?",
    },
    text: {
      type: String,
      default: "",
    },
    confirmText: {
      type: String,
      default: "Megerősítés",
    },
    cancelText: {
      type: String,
      default: "Mégse",
    },
    color: {
      type: String,
      default: "error",
    },
    icon: {
      type: String,
      default: "mdi-alert-circle-outline",
    },
  },
  emits: ["update:modelValue", "confirm", "cancel"],
});
</script>

<style scoped>
.confirm-dialog-card {
  overflow: hidden;
  background: radial-gradient(
      circle at top,
      rgba(var(--v-theme-primary), 0.08),
      transparent 42%
    ),
    linear-gradient(
      180deg,
      rgba(var(--v-theme-surface), 1),
      rgba(var(--v-theme-surface-bright), 0.96)
    );
}

.confirm-dialog-icon {
  width: 68px;
  height: 68px;
  display: grid;
  place-items: center;
  border-radius: 999px;
  margin-bottom: 18px;
  background: rgba(var(--v-theme-primary), 0.1);
}

.confirm-dialog-eyebrow {
  margin: 0 0 6px;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  font-size: 0.75rem;
  color: var(--app-soft-muted);
}

.confirm-dialog-title {
  margin: 0 0 12px;
  font-size: 1.5rem;
  line-height: 1.2;
}

.confirm-dialog-text {
  margin: 0;
  color: var(--app-muted);
  line-height: 1.7;
}
</style>
